module.exports = __webpack_public_path__ + "static/img/task.30f598aa.png";